import src from "IMAGE";
export default { src, width: 208, height: 131, blurWidth: 0, blurHeight: 0};
